__turbopack_context__.v({
  "ctaContainer": "StickyAddToCartBar-module-scss-module__tX4m3q__ctaContainer",
  "priceAndCta": "StickyAddToCartBar-module-scss-module__tX4m3q__priceAndCta",
  "priceBlock": "StickyAddToCartBar-module-scss-module__tX4m3q__priceBlock",
  "productInfo": "StickyAddToCartBar-module-scss-module__tX4m3q__productInfo",
  "productName": "StickyAddToCartBar-module-scss-module__tX4m3q__productName",
  "stickyBar": "StickyAddToCartBar-module-scss-module__tX4m3q__stickyBar",
  "stickyBarInner": "StickyAddToCartBar-module-scss-module__tX4m3q__stickyBarInner",
  "stickyBarVisible": "StickyAddToCartBar-module-scss-module__tX4m3q__stickyBarVisible",
  "thumbnail": "StickyAddToCartBar-module-scss-module__tX4m3q__thumbnail",
  "thumbnailImage": "StickyAddToCartBar-module-scss-module__tX4m3q__thumbnailImage",
});
